export class StepHeaderEntity {
  title;
  subTitle;
  icon;
  progress;
  constructor(title = "", subTitle = "", icon="", progress=0) {
    this.title = title;
    this.subTitle = subTitle;
    this.icon = icon;
    this.progress = progress;
  }
}
